import { render, staticRenderFns } from "./ChooseOtherPlanSection.vue?vue&type=template&id=4a9e0757&scoped=true"
import script from "./ChooseOtherPlanSection.vue?vue&type=script&lang=ts"
export * from "./ChooseOtherPlanSection.vue?vue&type=script&lang=ts"
import style0 from "./ChooseOtherPlanSection.vue?vue&type=style&index=0&id=4a9e0757&prod&lang=scss&scoped=true"
import style1 from "./ChooseOtherPlanSection.vue?vue&type=style&index=1&id=4a9e0757&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e0757",
  null
  
)

export default component.exports